import type { UiKey } from '@/i18n/dictionary';

/** Маршрут шага: catalog · saved · canvases · canvas-first (первый канвас пользователя). */
export interface OnboardingStep {
  key: string;
  /** Ключи словаря `tour.steps.<key>.*` — тексты лежат в locales/*.json. */
  section: UiKey;
  route: 'catalog' | 'saved' | 'canvases' | 'canvas-first';
  target: string;
  title: UiKey;
  body: UiKey;
}

/** Тексты тура — из data.js → onboarding (en), перевод в ru.json; правятся вместе с дизайн-пакетом (ONB-4). Прототип: 6 шагов. */
export const onboardingSteps: OnboardingStep[] = [
  {
    key: 'search',
    section: 'tour.steps.search.section',
    route: 'catalog',
    target: 'search',
    title: 'tour.steps.search.title',
    body: 'tour.steps.search.body',
  },
  {
    key: 'card',
    section: 'tour.steps.card.section',
    route: 'catalog',
    target: 'card',
    title: 'tour.steps.card.title',
    body: 'tour.steps.card.body',
  },
  {
    key: 'saved',
    section: 'tour.steps.saved.section',
    route: 'saved',
    target: 'nav-saved',
    title: 'tour.steps.saved.title',
    body: 'tour.steps.saved.body',
  },
  {
    key: 'canvases',
    section: 'tour.steps.canvases.section',
    route: 'canvases',
    target: 'canvas-new',
    title: 'tour.steps.canvases.title',
    body: 'tour.steps.canvases.body',
  },
  {
    key: 'canvas',
    section: 'tour.steps.canvas.section',
    route: 'canvas-first',
    target: 'canvas-tools',
    title: 'tour.steps.canvas.title',
    body: 'tour.steps.canvas.body',
  },
  {
    key: 'share',
    section: 'tour.steps.share.section',
    route: 'canvas-first',
    target: 'canvas-share',
    title: 'tour.steps.share.title',
    body: 'tour.steps.share.body',
  },
];
